import { __assign, __rest } from "tslib";
import * as animejs from 'animejs';
import * as React from 'react';
import animeManager from 'shared/anime/animeManager';
import { buildTransition, offsetTransforms } from 'shared/anime/animeUtils';
import { defaultStyles, fullSizeStyle } from 'shared/config';
import { translateTransformStyles } from 'shared/utils';
import { buildBackgroundStyle } from './symbolUtils';
export var AnimatableDiv = function (_a) {
    var children = _a.children, hoverAnimation = _a.hoverAnimation, innerRef = _a.innerRef, inEditor = _a.inEditor, position = _a.position, style = _a.style, rest = __rest(_a, ["children", "hoverAnimation", "innerRef", "inEditor", "position", "style"]) // Standard `<div>` attributes
    ;
    var hoverAnime = React.useMemo(function () {
        if (!hoverAnimation || !rest.id) {
            return;
        }
        // The Symbol's at-rest style, when it is not hovered.
        var restStyle = __assign(__assign(__assign({}, defaultStyles), style), { rotate: position ? position.rotate : '0deg' });
        var transition = buildTransition("#" + rest.id, restStyle, offsetTransforms(hoverAnimation.styles, restStyle), // hover styles
        0, hoverAnimation.duration || 125, hoverAnimation.easing || 'linear');
        // @ts-ignore animejs import
        return animejs(__assign(__assign({}, transition), { autoplay: false }));
    }, [hoverAnimation, position, rest.id, style]);
    /**
     * Check if the symbol can animate its hover animation
     * CAN hover when it:
     * - it has hover animation AND
     * - + [] when main timeline is inactive
     * - + [] when main timeline is active, but it does not have animation in the main timeline.
     */
    var canAnimateHover = function () {
        // Don't animate hovers in the editor.
        return !inEditor &&
            // We have an ID to check.
            !!rest.id &&
            // There is animation data to check against.
            !!animeManager.timePointData &&
            // This Symbol has hover animation data.
            !!hoverAnime &&
            // We are not animating, or this Symbol doesn't animate.
            (!animeManager.isAnimating() || !animeManager.timePointData[rest.id]);
    };
    var handleMouseEnter = function () {
        if (!canAnimateHover() || !hoverAnime) {
            return;
        }
        if (hoverAnime.reversed) {
            hoverAnime.reverse();
        }
        hoverAnime.play();
    };
    var handleMouseLeave = function () {
        if (!canAnimateHover() ||
            !hoverAnime ||
            !hoverAnime.began // MouseEnter never fired.
        ) {
            return;
        }
        if (!hoverAnime.reversed) {
            hoverAnime.reverse();
        }
        hoverAnime.play();
    };
    return (React.createElement("div", __assign({ onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, ref: innerRef, style: buildStyles(style, position) }, rest), children));
};
export default AnimatableDiv;
export var buildStyles = function (propStyles, position) {
    var positionStyles = position
        ? {
            position: 'absolute',
            height: "" + position.height,
            left: "" + position.left,
            top: "" + position.top,
            width: "" + position.width,
        }
        : fullSizeStyle;
    return __assign(__assign(__assign({ boxSizing: 'border-box' }, positionStyles), translateTransformStyles(propStyles, position && position.rotate)), { background: buildBackgroundStyle(propStyles) });
};
